module.exports = __webpack_public_path__ + "static/media/blocker_design.88e6dfed.png";